import ThongBaoSaiSotCTPage from "./ThongBaoSaiSotCTPage";

export default ThongBaoSaiSotCTPage;
